import React from "react";
import Header from "../../components/Header";
import TextField from "../../components/TextField";
import { FIELD_ERROR_TEXT } from "../../utils";
import canadaFlag from "../../assets/CanadaFlag.jpg";

const BranchDetails = ({
  data,
  setData,
  error,
  handleInputChange,
  offlineDisabled = false,
}) => {
  return (
    <div>
      <Header text="Download Registration Form" />

      <div className="form_container">
        <TextField
          label="Operating Name"
          name="download_op_name"
          value={data?.download_op_name}
          handleChange={handleInputChange}
          error_state={error?.download_op_name}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={offlineDisabled}
        />
        <TextField
          label="Legal Name of Brokerage"
          name="download_legal_broker_name"
          value={data?.download_legal_broker_name}
          handleChange={handleInputChange}
          error_state={error?.download_legal_broker_name}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={offlineDisabled}
        />
        <TextField
          label="General Email Address"
          name="download_gen_email"
          value={data?.download_gen_email}
          handleChange={handleInputChange}
          error_state={error?.download_gen_email}
          error_text={
            data?.download_gen_email && error?.download_gen_email
              ? "Please enter valid email"
              : FIELD_ERROR_TEXT
          }
          custom="email"
          required
          disabled={offlineDisabled}
        />
        <TextField
          label="Head Office Phone Number"
          name="download_ho_phone"
          value={data?.download_ho_phone}
          handleChange={handleInputChange}
          error_state={error?.download_ho_phone}
          error_text={
            data?.download_ho_phone && error?.download_ho_phone
              ? "Please enter valid phone"
              : FIELD_ERROR_TEXT
          }
          custom="phone"
          required
          disabled={offlineDisabled}
          addonBefore={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: ".875rem",
                fontWeight: "600",
              }}
            >
              <img
                style={{ height: "0.75rem", opacity: "0.7" }}
                src={canadaFlag}
                alt=""
              />
              <span>+1</span>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default BranchDetails;
